import React from 'react';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

/**  @type {() => (action:import('modules/global/generic.types').Action<U>) => (nextDispatch:import('redux').Dispatch) => Promise<T>} */
const createAsyncAction = action => nextDispatch =>
  new Promise((resolve, reject) => {
    nextDispatch({
      ...action,
      meta: {
        ...(action.meta ?? {}),
        resolve,
        reject,
        '@async': true,
        '@async-id': uuidv4(),
        '@async-root': action.type,
      },
    });
  });

/**
 * Wrap a standard Request Action and resolve with the payload of its SUCCESS action.
 * `dispatch` runs the thunk, so the caller awaits the payload — not the thunk.
 * @type {() => <T>(action: import("redux").UnknownAction) => Promise<T>}
 */
const useAsyncDispatch = () => {
  const dispatch = useDispatch();

  return React.useCallback(action => dispatch(createAsyncAction(action)), [dispatch]);
};

export default useAsyncDispatch;
